import { format, parseISO } from 'date-fns';
import { enUS, ru } from 'date-fns/locale';

/**
 * Dates that name a month or a day, written in the READER's language. A bare `format(d, 'MMM …')` has
 * no locale and prints "Oct" to a Russian therapist (audit AUDIT-ru-english-leaks §D, Q-ru-2 B).
 * Use these, or pass `{ locale: dateFnsLocaleFor(lng) }` yourself.
 */
export const isRu = (lng: string | undefined): boolean =>
  (lng ?? '').toLowerCase().startsWith('ru');

export const dateFnsLocaleFor = (lng: string | undefined) => (isRu(lng) ? ru : enUS);

/** A reminder's next occurrence (a local wall-clock string): "24 окт., 14:30" / "Oct 24, 2:30 PM". */
export const formatOccurrence = (local: string, lng: string | undefined): string =>
  format(parseISO(local), isRu(lng) ? 'd MMM, HH:mm' : 'MMM d, h:mm a', {
    locale: dateFnsLocaleFor(lng),
  });

/** A table-cell date and time: "24 окт. 2026 - 14:30" / "Oct 24, 2026 - 02:30 PM". */
export const formatDateTimeShort = (iso: string, lng: string | undefined): string =>
  format(parseISO(iso), isRu(lng) ? 'MMM dd, yyyy - HH:mm' : 'MMM dd, yyyy - hh:mm aaa', {
    locale: dateFnsLocaleFor(lng),
  });

/** A long day: "24 октября 2026" / "24 October, 2026". */
export const formatDayLong = (d: Date, lng: string | undefined): string =>
  format(d, isRu(lng) ? 'dd MMMM yyyy' : 'dd MMMM, yyyy', { locale: dateFnsLocaleFor(lng) });
